(ns humbleai.belt.malli.transform.translate-keys
  (:refer-clojure :exclude [compile])
  (:require
   [clojure.set :as set]
   [malli.core :as malli]
   [malli.transform :as malli.transform]))

(defn decode
  [[map-key {::keys [from from-any] :as props} _schema]]
  (when (contains? props ::from-any)
    (assert (or (set? from-any)
                (sequential? from-any)))
    (assert (not (contains? props ::from))))
  (cond
    from-any
    (into []
          (map (fn [k]
                 [k map-key]))
          from-any)

    from
    [[from map-key]]))

(defn encode
  [[map-key {::keys [from to encode-all-to] :as props} _schema]]
  (when (contains? props ::from-any)
    (assert (and (not (contains? props ::to))
                 (not (contains? props ::from)))))
  (when (contains? props ::from)
    (assert (not (contains? props ::encode-all-to))))
  [[map-key (or encode-all-to to from)]])

(defn compile
  ([map-key-schema->key-translation]
   (compile map-key-schema->key-translation nil))
  ([map-key-schema->key-translation stage]
   {:compile
    (fn translate-keys-map-decoder-compiler
      [schema _]
      (let [old->new-key (into {}
                               (comp (mapcat map-key-schema->key-translation)
                                     (remove nil?))
                               (malli/children schema))]
        (if (empty? old->new-key)
          identity
          (let [decoder (fn translate-keys-map-decoder
                          [entity]
                          (set/rename-keys entity old->new-key))]
            (if stage
              {stage decoder}
              decoder)))))}))

(def transformer
  (malli.transform/transformer
   {:name :translate-keys
    :decoders {:map (compile decode :enter)}
    :encoders {:map (compile encode :leave)}}))
